export enum CoreIntegrationTypes {
  avigilon = "avigilon",
  microsoft = "microsoft",
  google = "google"
}
